import type { InputSignal, PipeTransform } from '@angular/core';
import { Pipe } from '@angular/core';
import type { TableColumnConfig } from '../data/table-column-config';
import type { TableCellComponent } from '../cells/cell-factory/table-cell/table-cell.component';
import { isFunction } from '@pct-ts/typeguard';

export type RemoveInputSignal<T> = {
  [K in keyof T]: T[K] extends InputSignal<infer U> ? U : T[K];
};

export type RemoveReadonly<T> = {
  -readonly [K in keyof T]: T[K];
};

export type ResolveCellContentInputsPipeReturn<ROW, PARAMETERS> = RemoveReadonly<
  Partial<RemoveInputSignal<TableCellComponent<ROW, any, PARAMETERS>>>
>;

@Pipe({
  name: 'resolveCellContentInputs',
})
export class ResolveCellContentInputsPipe<ROW, PARAMETERS> implements PipeTransform {
  transform(
    rowItem: ROW,
    columnConfig: TableColumnConfig<ROW>,
  ): ResolveCellContentInputsPipeReturn<ROW, PARAMETERS> {
    const result: ResolveCellContentInputsPipeReturn<ROW, PARAMETERS> = {
      value: rowItem[columnConfig.field],
      rowItem,
      // params: column.cellCustomContent?.(element),
    };

    const cellCustomContent = columnConfig.cellCustomContent;
    if (isFunction(cellCustomContent)) {
      result.params = cellCustomContent(rowItem);
    }

    return result;
  }
}
